import React, { useState } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import InteractiveHouseSection from './components/InteractiveHouseSection';
import ProductSelectionPage from './components/ProductSelectionPage';
import ProductListing from './components/ProductListing';
import ProductPage from './components/ProductPage';
import ApplicationsPage from './components/ApplicationsPage';
import GalleryPage from './components/GalleryPage';
import FAQPage from './components/FAQPage';
import ContactPage from './components/ContactPage';
import DemoPage from './components/DemoPage';
import { Product } from './data/products';

type AppView = 'home' | 'products' | 'product-selection' | 'product-detail' | 'applications' | 'gallery' | 'faq' | 'contact' | 'coordinate-finder';

function App() {
  const [currentView, setCurrentView] = useState<AppView>('home');
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);

  const handleProductSelect = (product: Product) => {
    setSelectedProduct(product);
    setCurrentView('product-detail');
  };

  const handleBackToProducts = () => {
    setSelectedProduct(null);
    setCurrentView('products');
  };

  const handleBackToHome = () => {
    setCurrentView('home');
  };

  const renderContent = () => {
    switch (currentView) {
      case 'products':
        return <ProductListing onProductSelect={handleProductSelect} />;
      case 'product-selection':
        return <ProductSelectionPage onBack={handleBackToHome} />;
      case 'product-detail':
        return selectedProduct ? (
          <ProductPage product={selectedProduct} onBack={handleBackToProducts} />
        ) : null;
      case 'applications':
        return <ApplicationsPage onBack={handleBackToHome} />;
      case 'gallery':
        return <GalleryPage onBack={handleBackToHome} />;
      case 'faq':
        return <FAQPage onBack={handleBackToHome} />;
      case 'contact':
        return <ContactPage onBack={handleBackToHome} />;
      case 'coordinate-finder':
        return <DemoPage />;
      default:
        return (
          <>
            <HeroSection />
            <InteractiveHouseSection onNavigate={setCurrentView} />
          </>
        );
    }
  };

  return (
    <div className="App min-h-screen bg-gray-50">
      <Header onNavigate={setCurrentView} />
      <main>
        {renderContent()}
      </main>
    </div>
  );
}

export default App;
